import * as React from "react"
const OnboardingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 64 64"
    {...props}
  >
    <g fill="#fff">
      <path
        d="M20 14v-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h12v-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a4 4 0 0 0 4-4V8a3 3 0 0 0-3-3h-7V3a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v2h-7a3 3 0 0 0-3 3v2a4 4 0 0 0 4 4zm8-11a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h-8zm12 11h2v2h-2zm-18 0h2v2h-2zm1.2 34.038a2.5 2.5 0 0 0-3.52-.309l-5.366 4.5a2.5 2.5 0 0 0-.314 3.52 2.5 2.5 0 0 0 3.52.309l5.365-4.5a2.5 2.5 0 0 0 .315-3.52zm12.058 8.152a2.5 2.5 0 0 0-3.52-.309L27.905 59.1a2.5 2.5 0 0 0-.309 3.521 2.5 2.5 0 0 0 3.521.309l3.832-3.214a2.5 2.5 0 0 0 .309-3.526zM19.155 45.555a2.5 2.5 0 0 0 .309-3.521 2.5 2.5 0 0 0-3.521-.308l-4.6 3.856a2.5 2.5 0 0 0-.308 3.521 2.5 2.5 0 0 0 3.52.309zm9.306 7.201a2.5 2.5 0 0 0-3.521-.308l-3.833 3.213a2.5 2.5 0 0 0 3.212 3.83l3.833-3.213a2.5 2.5 0 0 0 .309-3.522zm7.774 8.488-2.951 2.473a2.483 2.483 0 0 0 3.5-3.033 4.5 4.5 0 0 1-.549.56z"
        data-original="#000000"
      />
      <rect
        width={24}
        height={5}
        x={-7.612}
        y={29.358}
        data-original="#000000"
        rx={1}
        transform="rotate(-79.98 4.392 31.856)"
      />
      <path
        d="m52.4 45.224-9.882-6.541a11 11 0 0 1-5.975-.411 10.335 10.335 0 0 1-5.646-4.85l-3.207.652-1.254 1.9a5.006 5.006 0 0 1-6.929 1.41 4.005 4.005 0 0 1-1.128-5.544l3.536-5.34a4.98 4.98 0 0 1 2.207-1.84l5.322-2.269a8.975 8.975 0 0 0-4.847-.6l-11.29 1.726-2.792-.492L7 42.934l.826.145a13.064 13.064 0 0 0 1.238 2.169 4.482 4.482 0 0 1 .99-1.2l4.6-3.858a4.485 4.485 0 0 1 7.1 4.987 4.467 4.467 0 0 1 4 4.774 4.459 4.459 0 0 1 5.259 4.01 4.471 4.471 0 0 1 6.787 4.38l.786.519a2.5 2.5 0 0 0 2.76-4.169l-6.255-4.14a1 1 0 1 1 1.1-1.667l7.922 5.243a2.5 2.5 0 1 0 2.76-4.169l-7.923-5.244a1 1 0 1 1 1.1-1.668l9.589 6.348a2.5 2.5 0 1 0 2.76-4.17z"
        data-original="#000000"
      />
      <rect
        width={5}
        height={24}
        x={57.113}
        y={19.859}
        data-original="#000000"
        rx={1}
        transform="rotate(-10.02 59.494 31.806)"
      />
      <path
        d="M50.692 23.512 39.4 21.786a9 9 0 0 0-4.889.618L24.907 26.5a3.01 3.01 0 0 0-1.325 1.1l-3.532 5.339a2 2 0 0 0 .564 2.772 3 3 0 0 0 4.157-.846l1.712-2.586 4.776-.972a.984.984 0 0 1 1.1.547 8.3 8.3 0 0 0 4.864 4.537 9 9 0 0 0 5.66.137 8.951 8.951 0 0 0 2.274-1.064v-.006l.843-.541a1 1 0 1 1 1.09 1.677l-.839.545a11.092 11.092 0 0 1-1.328.738l8.581 5.68a4.438 4.438 0 0 1 1.467 1.643 13.055 13.055 0 0 0 1.2-2.116l.829-.15-3.515-19.914zm-24.734-3.829a10.949 10.949 0 0 1 4.313.88L32 21.3l1.729-.737a10.949 10.949 0 0 1 4.313-.88 11.134 11.134 0 0 1 1.662.126L48 21.077V14.46A5.969 5.969 0 0 1 44 16v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1H26v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1a5.969 5.969 0 0 1-4-1.54v6.617l8.3-1.267a11 11 0 0 1 1.658-.127z"
        data-original="#000000"
      />
    </g>
  </svg>
)
export default OnboardingIcon
